import React, { useState } from "react";
import { AdminApiProvider } from "../../AdminApiContext";
import s from "../../admin_styles/AdminDashboard.module.css";

import TariffList  from "./TariffList";
import ServiceList from "./ServiceList";
import TariffForm  from "./TariffForm";
import ServiceForm from "./ServiceForm";

const TariffDashboard = () => {
  const [editTariff,  setEditTariff]  = useState(null);
  const [editService, setEditService] = useState(null);

  return (
    <AdminApiProvider>      {/* оборачиваем ВСЁ, что должно читать контекст */}
      <div className={s.main_div}>
        {/* --- Тарифы --------------------------------------------------- */}
        <TariffList onEdit={setEditTariff} />
        {editTariff && (
          <TariffForm
            key={editTariff.id}       /* чтобы форма сбрасывалась при смене */
            initial={editTariff}
            onClose={() => setEditTariff(null)}
          />
        )}

        {/* Пустая форма = создать новый */}
        {!editTariff && (
          <TariffForm
            onClose={() => {}}        /* можно скрыть через локальный state */
          />
        )}

        <hr />

        {/* --- Сервисы -------------------------------------------------- */}
        <ServiceList onEdit={setEditService} />

        {editService && (
          <ServiceForm
            key={editService.id}
            initial={editService}
            onClose={() => setEditService(null)}
          />
        )}

        {!editService && (
          <ServiceForm onClose={() => {}} />
        )}
      </div>
    </AdminApiProvider>
  );
};

export default TariffDashboard;
